import { moment } from "ngx-bootstrap/chronos/test/chain";
import { RetailerBrandsListItemDto } from "./retailers.model";

export interface PlanData {
    programFundingId: number;
    retailerId: number;
    brandId: number;
    budgetYear: number;
    brandName: string;
    jobsToBeDoneHeaderId: number;
    totalTarget: number;
    atlTarget: number;
    atlPlanned: number;
    atlUnplanned: number;
    btlTarget: number;
    btlPlanned: number;
    btlUnplanned: number;
    atlPrePLan: number;
    atlPrePlanRemaining: number;
    btlPrePlan: number;
    btlPrePlanRemaining: number;
    categoryId: number;
    atL_JobsToBeDoneRevisionsId?: number;
    btL_JobsToBeDoneRevisionsId?: number;
    selected: boolean;
}

export class ProgramDto {
    public id: number;
    public retailerId: number;
    public fiscalYear: number;
    public statusId: number;
    public name: string;
    public description: string;
    public note: string;
    public strategicBusinessInitiativeId: number;
    public programStartDate: Date;
    public programEndDate: Date;
    public campaignThemeId: number;
    public retailerName: string;
    public strategicBusinessInitiativeName: string;
    public createdBy: number;
    public createdDate: Date;
    public programFunding: ProgramFundingListItemDto[];
    public canSubmit: boolean;
    public canApprove: boolean;
    public hasProgramTactics: boolean;
    public campaignThemeTypeId: number;
    public campaignThemeTypeName: number;
    public selectedFundings: PlanData[];
    public programStatusID: number;
    fundingSources: Array<any> = [];
    accountLocations: Array<number>;

    constructor() {
        this.programFunding = new Array<ProgramFundingListItemDto>();
    }
    public static fixDates(obj: ProgramDto): ProgramDto {
        obj.programStartDate = obj.programStartDate == null ? null : moment(obj.programStartDate).toDate();
        obj.programEndDate = obj.programEndDate == null ? null : moment(obj.programEndDate).toDate();
        return obj;
    }
}

export class ProgramFundingListItemDto {
    public id: number;
    public programId: number;
    public jobsToBeDoneHeaderId: number;
    public allocationPercentage: number;
    public jobsToBeDoneHeaderBrandId: number;
    public jobsToBeDoneHeaderBrandName: string;
    public markedForDeletion: boolean;
    public atlFormatted: string;
    public btl: number;
    public btlFormatted: string;
    public totalAtlBtl: number;
    public totalFormatted: string;

    public static createFrom(value: RetailerBrandsListItemDto): ProgramFundingListItemDto {
        let item = new ProgramFundingListItemDto();
        item.jobsToBeDoneHeaderId = value.jobsToBeDoneHeaderId;
        item.jobsToBeDoneHeaderBrandId = value.brandId;
        item.jobsToBeDoneHeaderBrandName = value.brandName;
        return item;
    }
}

export class SaveProgramCommand {
    program: ProgramDto;
    accountLocations: Array<number>;
}

export class StrategicBusinessInitiativeLookupDto {
    public id: number;
    public name: string;
}

export class RetailerLookupDto {
    id: number;
    name: string;
}

export class BrandLookupDto {
    id: number;
    name: string;
}
export class ProgramId {
    constructor(public value: number) {

    }
}
export class BudgetYearLookupDto {
    id: number;
    fiscalYear: string;  
}
export class StateLookupDto {
    id: number;
    name: string;
    stateCode: string;
}

export class CountryLookupDto {
    id: number;
    name: string;
    countryCode: string;
}

export class CreateProgramShippingLocationCommand {
    shipping: ShippingLocationDto; 
}
export class ShippingLocationDto {
    public id: number;
    public programid: number;
    public companyName: string;
    public address1: string;
    public address2: string;
    public city: string;
    public state: string;
    public zip: string;
    public country: string;
    public phone: string;
    public deliveryDate: Date;
    public deliveryNotes: string;
    public attention: string;
    public saveToAddressBook: boolean;
    public delete: number;
}
export class ProgramDeliveryInformationDto {
    public id: number;
    public deliveryDate: Date;
    public deliveryNotes: string;
    public showDeliveryDate: number;
    public showDeliveryNotes: number;
    public showRetailer: number;
    public recordsCount: number;
    public totalPages: number;
    public programShippingLocation: ProgramShippingLocationDto[];

    constructor() {
        this.programShippingLocation = new Array<ProgramShippingLocationDto>();
    }

    public static fixDates(obj: ProgramDeliveryInformationDto): ProgramDeliveryInformationDto {
        obj.deliveryDate = obj.deliveryDate == null ? null : moment(obj.deliveryDate).toDate();
        return obj;
    }
}
export class ProgramShippingLocationDto {
    public id: number;
    public deliveryLocationId: number;
    public location: string;
    public markedForDeletion: boolean;
    public programId: number;
    public selected: boolean;
    public showEdit: boolean;
    public contactName: string;
    public distributed: boolean;
    public unitNumber?: any;
    public address: string;
    public emailOptIn: string;

    public static createFrom(value: DeliveryLocationLookupDto, programId: ProgramId): ProgramShippingLocationDto {
        let item = new ProgramShippingLocationDto();
        item.deliveryLocationId = value.id;
        item.location = value.location;
        item.programId = programId.value;
        item.selected = value.selected;
        item.showEdit = value.showEdit;
        item.address = value.address;
        item.contactName = value.contactName;
        item.unitNumber = value.unitNumber;
        item.emailOptIn = value.emailOptIn;
        return item;
    }
}

export class DeliveryLocationLookupDto {
    id: number;
    location: string;
    selected: boolean;
    showEdit: boolean;
    unitNumber?: any;
    address: string;
    contactName: string;
    emailOptIn: string;
}


// WEBPACK FOOTER //
// ./src/app/client-core/dtos/programs.model.ts